import 'dkfds/dist/css/dkfds.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Tooltip from '@/components/Tooltip.vue'
import 'focus-options-polyfill'
import VueDOMPurifyHTML from 'vue-dompurify-html';

const app = createApp(App)
app.use(store)
app.use(router)
// Register VueDOMPurifyHTML
app.use(VueDOMPurifyHTML);

app.component('Tooltip', Tooltip)

app.mount('#app')
